<template>
  <main :class="$options.name">
    <Head
      :title="$options.name + ' | Nice Bike'"
      description="We are a family owned small bicycle shop that is dedicated to bringing you the absolute best in cycling. We are Nice Bike."
      keywords="nice bike"
      image="https://ridenicebike.com/img/social.jpg"
      url="https://ridenicebike.com"
    />
    <article>
      <section class="innerWrap">
        <h1>{{ $options.name }}</h1>
        <hr />
        <section v-if="instagram.length" class="follow">
          <h2>Instagram</h2>
          <p>
            <a
              href="https://www.instagram.com/ridenicebike/"
              target="_blank"
              aria-label="Follow us on Instagram"
              rel="noopener"
            >
              Follow us
              <Icon name="external" :size="14" />
            </a>
          </p>
        </section>
        <Loader v-if="loading" />
      </section>
      <section :class="$options.name + '__instagram'" v-if="instagram.length">
        <span
          :class="$options.name + '__instagram--item'"
          v-for="item in instagram"
          :key="item.id"
        >
          <section class="Box">
            <Carousel
              v-if="item.media_type === 'CAROUSEL_ALBUM'"
              :caption="item.caption"
              :items="item.children.data"
            >
              <Img
                v-if="item.media_type === 'IMAGE'"
                :caption="item.caption"
                :src="item.media_url"
              />
              <Video
                v-if="item.media_type === 'VIDEO'"
                :caption="item.caption"
                :src="item.media_url"
              />
            </Carousel>
            <Img
              v-if="item.media_type === 'IMAGE'"
              :caption="item.caption"
              :src="item.media_url"
            />
            <Video
              v-if="item.media_type === 'VIDEO'"
              :caption="item.caption"
              :src="item.media_url"
            />
          </section>
        </span>
      </section>
      <section v-if="news.length" class="innerWrap">
        <h2>From the shop</h2>
        <Loader v-if="loading" />
      </section>
      <section :class="$options.name + '__news'" v-if="news.length">
        <NewsItem
          v-for="article in news"
          :key="article.sys.id"
          :path="article.fields.title"
          :src="article.fields.hero.fields.file.url"
          :title="article.fields.title"
        />
      </section>
    </article>
  </main>
</template>
<script>
import axios from "axios";
import Carousel from "@/components/Carousel";
import Icon from "@/components/Icon";
import Img from "@/components/Img";
import Loader from "@/components/Loader";
import NewsItem from "@/components/NewsItem";
import Video from "@/components/Video";
export default {
  name: "News",
  components: { Carousel, Icon, Img, Loader, NewsItem, Video },
  computed: {
    news() {
      return this.$store.state.news;
    },
  },
  data() {
    return {
      apiSpace: this.$store.state.apiSpace,
      apiToken: this.$store.state.apiToken,
      instagram: [],
      loading: true,
      IGSecret: this.$store.state.IGSecret,
      IGTokenLong: this.$store.state.IGToken,
    };
  },
  methods: {
    getPageContent() {
      const contentful = require("contentful");
      const client = contentful.createClient({
        space: this.apiSpace,
        accessToken: this.apiToken,
      });
      client
        .getEntry("3wInY8S9UIzcn4PgzWRFg0")
        .then((entry) => {
          this.apiKey = entry.fields.api;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getPageContent();
    // Refresh
    axios
      .get(
        "https://graph.instagram.com/refresh_access_token?grant_type=ig_refresh_token&access_token=" +
          this.IGTokenLong
      )
      .then((response) => {
        this.IGTokenLong = response.data.access_token;
      })
      .catch((error) => {
        console.error(error);
      });

    // Get posts
    axios
      .get(
        "https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,children{media_type,media_url}&access_token=" +
          this.IGTokenLong
      )
      .then((response) => {
        this.instagram = response.data.data;
      })
      .catch((error) => {
        this.errored = true;
      })
      .finally(() => (this.loading = false));
  },
};
</script>
<style lang="scss">
.News {
  .innerWrap {
    padding-top: 0;
    > * + * {
      margin-top: rem(16);
    }
  }
  h2 {
    color: var(--base-mid);
  }
  &__instagram {
    align-items: flex-start;
    display: flex;
    margin-left: rem(-16);
    margin-right: rem(-32);
    overflow-x: auto;
    padding-bottom: rem(16);
    scroll-snap-type: x mandatory;
    scroll-padding: rem(16);
    &::-webkit-scrollbar {
      display: none;
    }
    &--item {
      flex: 0 0 calc(100% - 4em);
      padding: rem(16);
      scroll-snap-align: start;
      @include breakpoint(xsl) {
        flex-basis: calc((100% / 2) - 2em);
      }
      @include breakpoint(l) {
        flex-basis: calc((100% / 3) - 2em);
      }
      @include breakpoint(xl) {
        flex-basis: calc((100% / 4) - 2em);
      }
      &:last-child {
        padding-right: rem(32);
      }
      .Box {
        padding: 0;
      }
    }
  }
  &__news {
    align-items: start;
    display: grid;
    grid-gap: rem(16);
    grid-template-columns: repeat(auto-fit, minmax(rem(320), 1fr));
    justify-items: center;
    margin: rem(16) 0;
    @include breakpoint(l) {
      grid-template-columns: repeat(auto-fit, minmax(rem(480), 1fr));
    }
    @include breakpoint(xl) {
      grid-template-columns: repeat(auto-fit, minmax(rem(560), 1fr));
    }
  }
  .follow {
    align-items: center;
    display: flex;
    justify-content: space-between;
    p,
    a {
      align-items: center;
      display: inline-flex;
    }
    .Icon {
      margin-left: rem(8);
    }
  }
}
</style>
